// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type YourBookingsContextProperties = {
  bookings_count: number;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/your_bookings_context/jsonschema/2-0-0';
export const yourBookingsContextName = 'your_bookings_context';
export class YourBookingsContext extends BaseTrackingContext<YourBookingsContextProperties> {
  constructor(properties: YourBookingsContextProperties) {
    super(yourBookingsContextName, schema, properties);
  }
}
